var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMagnifierDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.9 9.5C15.9 13.0346 13.0346 15.9 9.5 15.9C5.96538 15.9 3.1 13.0346 3.1 9.5C3.1 5.96538 5.96538 3.1 9.5 3.1C13.0346 3.1 15.9 5.96538 15.9 9.5ZM14.5182 15.0739C13.1892 16.2712 11.4297 17 9.5 17C5.35786 17 2 13.6421 2 9.5C2 5.35786 5.35786 2 9.5 2C13.6421 2 17 5.35786 17 9.5C17 11.3164 16.3543 12.9821 15.2798 14.2798L22 21L21.2222 21.7778L14.5182 15.0739Z"
})));
export default SvgIconMagnifierDark;